import { render } from "./QAPage.vue?vue&type=template&id=523cacd7"
import script from "./QAPage.vue?vue&type=script&lang=js"
export * from "./QAPage.vue?vue&type=script&lang=js"

import "./QAPage.vue?vue&type=style&index=0&id=523cacd7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__